import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import logo from '../../assets/YAWAY.svg';

export interface ThemeState {
  color: string;
  logo: string | undefined;
}

const initialState: ThemeState = {
  color: '#36BB7B',
  logo: logo,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state: ThemeState, action: PayloadAction<any>) => {
      state.logo = action.payload.logo;
      state.color = action.payload.color;
    },
  },
});

const { actions, reducer } = themeSlice;

export const { setTheme } = actions;

export default reducer;
